class ProductTile extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector("button");
  }
  connectedCallback() {
    if (this.button) {
      this.button.addEventListener("click", (e) => {
        e.stopPropagation();
        this.toggle();
      });
    }
  }
  toggle() {
    this.classList.toggle("expanded");

    if (this.classList.contains("expanded")) {
      this.style.setProperty("position", "absolute");
      const delay = setTimeout(() => {
        this.style.setProperty("overflow", "auto");
      }, 500);
    } else {
      this.style.setProperty("overflow", "hidden");
      const delay = setTimeout(() => {
        this.style.setProperty("position", "relative");
      }, 500);
    }
  }
}
if (!customElements.get("product-tile")) {
  customElements.define("product-tile", ProductTile);
}
